/*
 * Jira Ticket:
 * Created Date: Thu, 10th Dec 2020, 15:05:20 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import * as React from 'react';
import { Layout } from 'react-admin';
import CustomMenu from './Menu';
import defaultTheme from 'theme'


const CustomLayout = props => <Layout {...props} menu={CustomMenu} theme={defaultTheme} />;

export default CustomLayout;
